module.exports = __webpack_public_path__ + "static/media/close-k-20.3d472f3f.png";